<template>
  <div>
    <AdminAppBar />
    <v-container fluid class="text-center">
      <Appointments></Appointments>
      <Scheduler :admin="true"></Scheduler>
    </v-container>
  </div>
</template>
<script>
import { db } from "../firebase/firebase";
import UtilsMixin from "../mixins/UtilsMixin";
import Appointments from "../components/Appointments";
import Scheduler from "../components/Scheduler";
import AdminAppBar from "../components/core/AdminAppBar";

export default {
  name: "Admin",
  components: {
    AdminAppBar,
    Appointments,
    Scheduler,
  },
  mixins: [UtilsMixin],
  firestore() {
    return {
      calEvent: db.collection("calEvent"),
      users: db.collection("users"),
    };
  },
};
</script>
